<template>
  <van-popup class="nav_popup" v-model="nav_show" @close="onClose">
    <div class="nav_box">
      <img class="nav_bg_img"
        :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_bg.png')" />
      <img class="nav_0_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_0.png')"
        @click="onNavClick({ url: 'https://cmcwdj.cssc-cmc.com/employ/' })" />
      <img class="nav_1_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_1.png')"
        @click="onNavClick({ name: 'employ.company' })" />
      <img class="nav_2_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_2.png')"
        @click="onNavClick({ name: 'employ.position.list', query: { position_type: '社会招聘' } })" />
      <img class="nav_3_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_3.png')"
        @click="onNavClick({ name: 'employ.position.list', query: { position_type: '校园招聘' } })" />
      <img class="nav_4_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_4.png')"
        @click="onNavClick({ name: 'employ.position.list', query: { position_type: '实习生招聘' } })" />
      <img class="nav_5_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_5.png')"
        @click="onNavClick({ name: 'employ.position.list', query: { position_type: '内部推荐' } })" />
      <img class="nav_6_img" :src="Util.getImgUrl('https://static.zhenhuixuan365.com/static/employ/images/navi_6.png')"
        @click="onNavClick({ name: 'employ.mine' })" />
    </div>
  </van-popup>
</template>
<script>
export default {
  name: 'employNav',
  props: {
    nav_show: Boolean
  },
  methods: {
    onClose() {
      this.$emit('update:nav_show', false)
    },
    onNavClick(obj) {
      let that = this
      that.nav_show = false
      if (obj) {
        setTimeout(() => {
          if (obj.url) {
            window.location.href = obj.url
          } else if (obj.name) {
            that.$router.push(obj)
          }
        }, 100)
      }
    }
  }
}
</script>
<style scoped>
.nav_popup {
  background-color: transparent;
}

.nav_box {
  position: relative;
}

.nav_bg_img {
  width: 537px;
  height: 624px;
}

.nav_0_img {
  width: 145px;
  /* height: 100px; */
  position: absolute;
  top: 250px;
  left: 196px;
}

.nav_1_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  top: 50px;
  left: 206px;
}

.nav_2_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  top: 150px;
  right: 15px;
}

.nav_3_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  bottom: 180px;
  right: 15px;
}

.nav_4_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  bottom: 65px;
  left: 206px;
}

.nav_5_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  bottom: 180px;
  left: 15px;
}

.nav_6_img {
  width: 125px;
  /* height: 100px; */
  position: absolute;
  top: 150px;
  left: 15px;
}
</style>